export default [
  'authorization',
  'orca-users',
  'cargoes',
  'vessels',
  'vessel_situations',
  'vessel_prefixes',
  'vessel_documents',
  'vessel_document_types',
  'vessel_types',
  'vessel_subtypes',
  'ports',
  'ports_map',
  'countries',
  'organizations',
  'report_types',
  'market-indexes',
  'vts',
  'widget_types',
  'cp_forms',
  'classification_societies',
  'routing_areas',
  'fuel_grades',
  'log_reports',
  'crons',
  'routes',
  'airports',
  'airlines',
  'crew_identifiers',
  'crew_statuses',
  'crew_evaluation_criteria',
  'crew_evaluation_criteria_categories',
  'crew_evaluation_template_types',
  'crew_evaluation_template_reasons',
  'crew_rank',
  'units',
  'agent_types',
  'countries',
  'currencies',
  'tools',
  'laytime_events',
  'ld_terms',
  'email_logs',
  'nationalities',
  'beacon_posts',
  'crew_matrices',
  'event_types',
  'purchasing_groups',
  'purchasing_stores',
  'equivalent_items',
  'purchasing_stores_unlinked'
];
